// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__2CdGg","inputWrap":"styles_inputWrap__3TghF","input":"styles_input__2Y9Mt"};